<!-- eslint-disable vue/no-mutating-props -->
<template>
  <card class="stacked-form" :title="computedTitle" :on-cancel="cancel">
    <Form ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(saveCar)">
        <div class="row">
          <div class="col-md-6">
            <material-input-field
              id="nameInput"
              ref="nameInput"
              v-model="name"
              :name="'name'"
              variant="static"
              :label="$t('common.name') + ' *'"
              :placeholder="$t('common.name')"
            />
            <material-input-field
              id="licencePlateInput"
              ref="licencePlateInput"
              v-model="licencePlate"
              :name="'licencePlate'"
              variant="static"
              :label="$t('cars.licencePlate') + ' *'"
              :placeholder="$t('cars.licencePlate')"
            />
            <div class="row">
              <div class="col-sm-6 mb-3">
                <label>{{ $t('cars.category') }}</label>
                <el-select v-model="vehicleCategory" clearable size="large" class="w-100" :placeholder="$t('cars.category')">
                  <el-option v-for="option in vehicleCategories" :key="option.value" :value="option.value" :label="$t(option.labelKey)" />
                </el-select>
              </div>
              <div class="col-sm-6 mb-3">
                <label>{{ $t('cars.fuelType') }}</label>
                <el-select v-model="fuelType" clearable size="large" class="w-100" :placeholder="$t('cars.fuelType')">
                  <el-option v-for="option in fuelTypes" :key="option.value" :value="option.value" :label="$t(option.labelKey)" />
                </el-select>
              </div>
              <div class="col-sm-6">
                <material-input-field
                  id="seatsInput"
                  v-model="seats"
                  name="seats"
                  type="number"
                  min="0"
                  variant="static"
                  :label="$t('cars.seats')"
                  :placeholder="$t('cars.seats')"
                />
              </div>
              <div class="col-sm-6 d-flex align-items-center mb-3">
                <material-checkbox id="isVatVehicle" v-model="isVatVehicle">
                  {{ $t('cars.isVatVehicle') }}
                </material-checkbox>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="col-md-9">
              <image-upload
                :src="imageSrc"
                :show-upload-button="false"
                :select-text="$t('image.selectImage')"
                @change="handleFileUpload"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 mb-3">
            <label>{{ $t('cars.registrationDate') }}</label>
            <el-date-picker v-model="registrationDate" type="date" format="DD/MM/YYYY" value-format="YYYY-MM-DD" class="w-100" :placeholder="$t('cars.registrationDate')" />
          </div>
          <div class="col-md-4 mb-3">
            <label>{{ $t('cars.lastInspection') }}</label>
            <el-date-picker v-model="lastInspectionDate" type="date" format="DD/MM/YYYY" value-format="YYYY-MM-DD" class="w-100" :placeholder="$t('cars.lastInspection')" />
          </div>
          <div class="col-md-4 mb-3">
            <label>{{ $t('cars.nextInspection') }}</label>
            <el-date-picker v-model="nextInspectionDate" type="date" format="DD/MM/YYYY" value-format="YYYY-MM-DD" class="w-100" :placeholder="$t('cars.nextInspection')" />
            <small class="text-secondary">{{ $t('cars.nextInspectionHint') }}</small>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <material-input-field
              id="odometerKmInput"
              v-model="odometerKm"
              name="odometerKm"
              type="number"
              min="0"
              variant="static"
              :label="$t('cars.odometerKm')"
              :placeholder="$t('cars.odometerKm')"
            />
          </div>
          <div class="col-md-4 mb-3">
            <label>{{ $t('cars.odometerDate') }}</label>
            <el-date-picker v-model="odometerDate" type="date" format="DD/MM/YYYY" value-format="YYYY-MM-DD" class="w-100" :placeholder="$t('cars.odometerDate')" @change="odometerDateTouched = true" />
          </div>
          <div class="col-md-4">
            <material-input-field
              id="commentInput"
              v-model="comment"
              name="comment"
              variant="static"
              :label="$t('cars.comment')"
              :placeholder="$t('cars.comment')"
            />
          </div>
        </div>
        <div v-if="customFields.length > 0" class="row">
          <div v-for="field in customFields" :key="field.id" class="col-md-4 mb-3">
            <material-checkbox
              v-if="field.fieldType === CUSTOM_FIELD_TYPE.YES_NO"
              :id="'customField-' + field.id"
              :model-value="customValues[field.propertyKey] === 'true'"
              @update:model-value="checked => customValues[field.propertyKey] = checked ? 'true' : 'false'"
            >
              {{ field.name }}
            </material-checkbox>
            <template v-else-if="field.fieldType === CUSTOM_FIELD_TYPE.DATE">
              <label>{{ field.name }}</label>
              <el-date-picker v-model="customValues[field.propertyKey]" type="date" format="DD/MM/YYYY" value-format="YYYY-MM-DD" class="w-100" :placeholder="field.name" />
            </template>
            <material-input-field
              v-else
              :id="'customField-' + field.id"
              v-model="customValues[field.propertyKey]"
              :name="field.propertyKey"
              :type="field.fieldType === CUSTOM_FIELD_TYPE.NUMBER ? 'number' : 'text'"
              variant="static"
              :label="field.name"
              :placeholder="field.name"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button color="dark" @click="saveCar">
              {{$t('common.submit')}}
            </material-button>
          </div>
        </div>
      </form>
    </Form>
  </card>
</template>
<script>
import api from "../../services/api"
import { Form } from 'vee-validate';
import { ElSelect, ElOption, ElDatePicker } from 'element-plus';
import ImageUpload from '../../components/ImageUpload.vue';
import Card from "../../components/Card.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import {
  CAR_TOOL_GROUP_TYPE_ID, VEHICLE_CATEGORIES, FUEL_TYPES, CUSTOM_FIELD_TYPE, toDateInput, customFieldValue
} from './carHelper';

export default {
  components: {
    Form,
    ElSelect,
    ElOption,
    ElDatePicker,
    ImageUpload,
    Card,
    MaterialInputField,
    MaterialButton,
    MaterialCheckbox
  },
  props: {
    editMode: {
      type: Boolean,
      required: true
    },
    // The car (GET /ToolGroup/{id}) being edited; null when creating
    car: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ['close', 'saved'],
  data() {
    const car = this.car || {};
    const valueOrEmpty = value => (value === null || value === undefined ? '' : value);
    return {
      CUSTOM_FIELD_TYPE,
      vehicleCategories: VEHICLE_CATEGORIES,
      fuelTypes: FUEL_TYPES,
      carId: car.id || '',
      name: car.name || '',
      licencePlate: (car.toolGroupProperties || []).find(p => p.key === 'licencePlate')?.value || '',
      toolGroupImageBytes: car.toolGroupImageBytes || '',
      imageChanged: false,
      vehicleCategory: car.vehicleCategory || null,
      fuelType: car.fuelType || null,
      registrationDate: toDateInput(car.registrationDate),
      lastInspectionDate: toDateInput(car.lastInspectionDate),
      nextInspectionDate: toDateInput(car.nextInspectionDate),
      odometerKm: valueOrEmpty(car.odometerKm),
      odometerDate: toDateInput(car.odometerDate),
      odometerDateTouched: false,
      seats: valueOrEmpty(car.seats),
      isVatVehicle: car.isVatVehicle === true,
      comment: car.comment || '',
      customFields: [],
      customValues: {}
    };
  },
  computed: {
    computedTitle() {
      return this.editMode ? this.$t('cars.editCar') : this.$t('cars.createCar');
    },
    imageSrc() {
      return this.toolGroupImageBytes ? 'data:image/png;base64,' + this.toolGroupImageBytes : '';
    }
  },
  watch: {
    // A new odometer reading is dated today unless the user picks the date themselves
    odometerKm(newValue, oldValue) {
      if (String(newValue) === String(oldValue)) return;
      if (!this.odometerDateTouched) {
        this.odometerDate = new Date().toISOString().slice(0, 10);
      }
    }
  },
  created() {
    this.fetchCustomFields();
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    async fetchCustomFields() {
      try {
        const response = await api.get(`/ToolGroupCustomField?toolGroupTypeId=${CAR_TOOL_GROUP_TYPE_ID}`);
        const properties = this.car ? this.car.toolGroupProperties : [];
        const values = {};
        response.data.forEach(field => {
          values[field.propertyKey] = customFieldValue(properties, field);
        });
        this.customValues = values;
        this.customFields = response.data;
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.error(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      }
    },
    buildRequestBody() {
      const existingKeys = new Set(((this.car && this.car.toolGroupProperties) || []).map(p => p.key));
      const properties = [{ key: 'licencePlate', value: this.licencePlate }];
      this.customFields.forEach(field => {
        const raw = this.customValues[field.propertyKey];
        const value = raw === null || raw === undefined ? '' : String(raw).trim();
        // Send an empty value only to clear one that was set before
        if (value !== '' || existingKeys.has(field.propertyKey)) {
          properties.push({ key: field.propertyKey, value });
        }
      });
      const numberOrNull = value => (value === '' || value === null ? null : Number(value));

      const requestBody = {
        toolgrouptypeid: CAR_TOOL_GROUP_TYPE_ID,
        name: this.name,
        properties,
        vehicleCategory: this.vehicleCategory || null,
        fuelType: this.fuelType || null,
        registrationDate: this.registrationDate || null,
        lastInspectionDate: this.lastInspectionDate || null,
        nextInspectionDate: this.nextInspectionDate || null,
        odometerKm: numberOrNull(this.odometerKm),
        odometerDate: this.odometerDate || null,
        seats: numberOrNull(this.seats),
        isVatVehicle: this.isVatVehicle,
        comment: this.comment || null
      };
      if (this.editMode) {
        requestBody.updateVehicleDetails = true;
      }
      // Only send the image when a new one was picked, so edits don't re-upload it
      if (this.imageChanged && this.toolGroupImageBytes !== '') {
        requestBody.toolGroupImageBytes = this.toolGroupImageBytes;
      }
      return requestBody;
    },
    async saveCar() {
      if (this.validateInput()) {
        const requestBody = this.buildRequestBody();
        if (this.editMode) {
          this.editCar(requestBody);
        }
        else {
          this.createCar(requestBody);
        }
      }
    },
    async createCar(requestBody) {
      await api.post('/ToolGroup', requestBody)
        .then(response =>
        {
          this.$toast.success(this.name + " " + this.$t('common.created'), { timeout: 1500 });
          this.$router.push({ name: 'Car', params: { toolGroupId: response.data.id.toString() } });
        }).catch(error =>
        {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.error(this.$t('common.unableToCreate'), { timeout: 0 });
        });
    },
    async editCar(requestBody) {
      await api.put(`/ToolGroup/${this.carId}`, requestBody)
        .then(response =>
        {
          this.$toast.success(`${this.name} ${this.$t('common.edit')}`, { timeout: 1500 });
          // The push is a no-op when editing from the car page itself, which reloads on 'saved'
          this.$emit('saved');
          this.$router.push({ name: 'Car', params: { toolGroupId: response.data.id.toString() } });
        }).catch(error =>
        {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.error(this.$t('common.unableToUpdate'), { timeout: 0 });
        });
    },
    handleFileUpload(file) {
      this.imageChanged = true;
      if(file){
        const reader = new FileReader();

        reader.onloadend = () => {
          let binary = '';
          const bytes = new Uint8Array(reader.result);
          bytes.forEach((byte) => binary += String.fromCharCode(byte));
          this.toolGroupImageBytes = btoa(binary);
        };
        reader.readAsArrayBuffer(file);
      }
      else{
        this.toolGroupImageBytes = ''
      }
    },
    validateInput() {
      let success = true;
        if (this.name === '') {
          this.$toast.info(this.$t('errors.nameEmpty'), { timeout: 2500 });
          success = false;
        }
        else if (this.licencePlate === '') {
          this.$toast.info(this.$t('errors.licencePlateEmpty'), { timeout: 2500 });
          success = false;
        }
        // Imported cars have no image, so it's only required when creating
        else if (!this.editMode && this.toolGroupImageBytes === '') {
          this.$toast.info(this.$t('errors.imageEmpty'), { timeout: 2500 });
          success = false;
        }
        return success;
    }
  }
};
</script>
<style></style>
